import { formatPrice } from '@/services/formatter';
import type { KeysToCamelCase } from '@/types/app';

type BaseType = {
  insurance_name?: string;
  insurance_amount?: number;
  insurance_term?: number;
};

export const getBaseAdditionalProducts = (
  item: BaseType & KeysToCamelCase<BaseType>
) => {
  const insuranceName = item.insuranceName || item.insurance_name;
  const insuranceAmount = item.insuranceAmount || item.insurance_amount;
  const insuranceTerm = item.insuranceTerm || item.insurance_term;
  const baseProduct = [
    insuranceName || (insuranceAmount ? 'КАСКО' : undefined),
    insuranceAmount ? `${formatPrice(insuranceAmount)} ₸` : undefined,
    insuranceTerm ? `${insuranceTerm} м.` : undefined
  ]
    .filter(Boolean)
    .join(' | ');
  return baseProduct ? [baseProduct] : [];
};
